import React, { useEffect } from "react";

/** Pinned semver — override with REACT_APP_NOCODEAPI_EMBED_SCRIPT_SRC if needed */
const DEFAULT_NOCODE_EMBED_SCRIPT =
  "https://unpkg.com/@nocodeapi/embed-instagram-feed@0.0.3/embed-instagram-feed.js?module";

const SCRIPT_ID = "nocodeapi-embed-instagram-feed-esm";

/**
 * NoCodeAPI Instagram feed (Lit `<embed-instagram-feed>`).
 * `feedUrl` must be your NoCodeAPI endpoint URL — not instagram.com/profile.
 *
 * @see https://github.com/nocodeapi/embed-instagram-feed
 * @see https://nocodeapi.com/instagram-api
 */
export default function InstagramNocodeApiEmbed({ feedUrl }) {
  const scriptSrc =
    typeof process.env.REACT_APP_NOCODEAPI_EMBED_SCRIPT_SRC === "string" &&
    process.env.REACT_APP_NOCODEAPI_EMBED_SCRIPT_SRC.trim()
      ? process.env.REACT_APP_NOCODEAPI_EMBED_SCRIPT_SRC.trim()
      : DEFAULT_NOCODE_EMBED_SCRIPT;

  useEffect(() => {
    if (!feedUrl || !String(feedUrl).trim()) return undefined;
    if (document.getElementById(SCRIPT_ID)) return undefined;
    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.type = "module";
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = scriptSrc;
    document.head.appendChild(s);
    return undefined;
  }, [feedUrl, scriptSrc]);

  if (!feedUrl || !String(feedUrl).trim()) return null;

  return (
    <div className="instagram__nocodeWrap">
      {React.createElement("embed-instagram-feed", { url: String(feedUrl).trim() })}
    </div>
  );
}
